module.exports = __webpack_public_path__ + "img/banner1.c103766f.png";